import { createContext } from "react";
import menu1 from '../img/menu-1.jpg';
import menu2 from "../img/menu-2.jpg";
import menu3 from "../img/menu-3.jpg";
import menu4 from "../img/menu-4.jpg";
import menu5 from "../img/menu-5.jpg";
import menu6 from "../img/menu-6.jpg";
import menu7 from "../img/menu-7.jpg";
import menu8 from "../img/menu-8.jpg";
import menu9 from "../img/menu-9.jpg";
import menu10 from "../img/menu-10.jpg";
import menu11 from "../img/menu-11.jpg";
import menu12 from "../img/menu-12.jpg";
import menu13 from "../img/menu-13.jpg";
import menu14 from "../img/menu-14.jpg";
import menu15 from "../img/menu-15.jpg";
import menu16 from "../img/menu-16.jpg";
import menu17 from "../img/menu-17.jpg";
import menu18 from "../img/menu-18.jpg";
import menu19 from "../img/menu-19.jpg";
import menu20 from "../img/menu-20.jpg";
import menu21 from "../img/menu-21.jpg";
import menu22 from "../img/menu-22.jpg";
import menu23 from "../img/menu-23.jpg";
import menu24 from "../img/menu-24.jpg";
import menu25 from "../img/menu-25.jpg";
import menu26 from "../img/menu-26.jpg";
import menu27 from "../img/menu-27.jpg";
import menu28 from "../img/menu-28.jpg";
import menu29 from "../img/menu-29.jpg";
import menu30 from "../img/menu-30.jpg";
import menu31 from "../img/menu-31.jpg";
import menu32 from "../img/menu-32.jpg";
import menu33 from "../img/menu-33.jpg";
import menu34 from "../img/menu-34.jpg";
import menu35 from "../img/menu-35.jpg";
import menu36 from "../img/menu-36.jpg";
import menu37 from "../img/menu-37.jpg";
import menu38 from "../img/menu-38.jpg";
import menu39 from "../img/menu-39.jpg";
import menu40 from "../img/menu-40.jpg";
import menu41 from "../img/menu-41.jpg";
import menu42 from "../img/menu-42.jpg";
import menu43 from "../img/menu-43.jpg";
import menu44 from "../img/menu-44.jpg";
import menu45 from "../img/menu-45.jpg";

 const MenuList = createContext([
   {
     name: "Banana Split",
     image: menu1,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 30,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Chicken Marengo",
     image: menu2,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 20,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Lobster Newburg",
     image: menu3,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 35,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Peach Melba",
     image: menu4,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 80,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Waldorf Salad",
     image: menu5,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 40,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Pizza",
     image: menu6,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 25,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Eggs Benedict",
     image: menu7,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 30,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Delmonico Steak",
     image: menu8,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 50,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Grilled Chicken",
     image: menu9,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 32,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Steak Sandwich",
     image: menu10,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 38,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Spaghetti",
     image: menu11,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 42,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Chicken Stirfry",
     image: menu12,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 78,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Grilled Veggies",
     image: menu13,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 98,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Battered Shrimp",
     image: menu14,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 25,
     orderOnline: false,
     type: "main dishes",
     mealTime: "dinner",
   },
   {
     name: "Fajitas",
     image: menu15,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 54,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Nachos",
     image: menu16,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 61,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Enchilladas",
     image: menu17,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 58,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "BBQ Ribs",
     image: menu18,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 46,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Hot Wings",
     image: menu19,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 67,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Chicken Cordon Bleu",
     image: menu20,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 72,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Apple Pie",
     image: menu21,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 84,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Mocha Cheesecake",
     image: menu22,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 24,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Meatballs",
     image: menu23,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 36,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Meatballs",
     image: menu24,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 54,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Chicken Fingers",
     image: menu25,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 61,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Beans on toast",
     image: menu26,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 58,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Beef Wellington	",
     image: menu27,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 63,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Bubble",
     image: menu28,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 75,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Cauliflower cheese",
     image: menu29,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 35,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Cottage pie",
     image: menu30,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 71,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Devilled kidneys",
     image: menu31,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 47,
     orderOnline: false,
     type: "main dishes",
     mealTime: "launch",
   },
   {
     name: "Lincolnshire sausage",
     image: menu32,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 49,
     orderOnline: false,
     type: "desert",
     mealTime: "launch",
   },
   {
     name: "Pasty",
     image: menu33,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 57,
     orderOnline: false,
     type: "desert",
     mealTime: "breakfast",
   },
   {
     name: "Pease pudding",
     image: menu34,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 43,
     orderOnline: false,
     type: "desert",
     mealTime: "breakfast",
   },
   {
     name: "Pork pie",
     image: menu35,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 36,
     orderOnline: false,
     type: "desert",
     mealTime: "breakfast",
   },
   {
     name: "Potted shrimps",
     image: menu36,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 24,
     orderOnline: false,
     type: "desert",
     mealTime: "breakfast",
   },
   {
     name: "Rag pudding",
     image: menu37,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 26,
     orderOnline: false,
     type: "desert",
     mealTime: "breakfast",
   },
   {
     name: "Strawberry Juice ",
     image: menu38,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 11,
     orderOnline: false,
     type: "drinks",
     mealTime: "breakfast",
   },
   {
     name: "lemon Juice",
     image: menu39,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 8,
     orderOnline: false,
     type: "drinks",
     mealTime: "breakfast",
   },
   {
     name: "Orange Juice",
     image: menu40,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 7,
     orderOnline: false,
     type: "drinks",
     mealTime: "breakfast",
   },
   {
     name: "Pepsi Cola",
     image: menu41,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 4,
     orderOnline: false,
     type: "drinks",
     mealTime: "breakfast",
   },
   {
     name: "Mint Drink ",
     image: menu42,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 5,
     orderOnline: false,
     type: "drinks",
     mealTime: "breakfast",
   },
   {
     name: "Sunday roast",
     image: menu43,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 9,
     orderOnline: false,
     type: "main dishes",
     mealTime: "breakfast",
   },
   {
     name: "Yorkshire pudding",
     image: menu44,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 29,
     orderOnline: false,
     type: "main dishes",
     mealTime: "breakfast",
   },
   {
     name: "Bakewell tart",
     image: menu45,
     description: "Ipsum ipsum clita erat amet dolor justo diam",
     price: 42,
     orderOnline: false,
     type: "main dishes",
     mealTime: "breakfast",
   },
 ]);
export default MenuList